module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_agder_pos.9cc133b6.pdf";